module.exports = __webpack_public_path__ + "static/media/profile.f43c998f.png";